import { render, staticRenderFns } from "./Theme1.vue?vue&type=template&id=1f01974a&scoped=true"
import script from "./Theme1.vue?vue&type=script&lang=js"
export * from "./Theme1.vue?vue&type=script&lang=js"
import style0 from "./Theme1.vue?vue&type=style&index=0&id=1f01974a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01974a",
  null
  
)

export default component.exports